var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('input',{staticStyle:{"opacity":"1"},attrs:{"multiple":"true","type":"file","accept":"application/JSON"},on:{"input":function($event){return _vm.importapp($event.target.files)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }